import { render } from "./AddBlackbox.vue?vue&type=template&id=be46b318"
import script from "./AddBlackbox.vue?vue&type=script&lang=js"
export * from "./AddBlackbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__